module.exports = __webpack_public_path__ + "media/images/fr_ca/performance_index_continuum-84687f97770d43190fe5d2386bd917ba.png";